import { PeerParticipant } from '@givebacks/api/store';
import { MantineTable } from 'ui';

import { ActivityLogTableRow } from './ActivityLogTableRow';

const ActivityLogTable = ({
  participant,
  units,
}: {
  participant: PeerParticipant;
  units?: string;
}) => {
  const total = participant?.activity_log.reduce((total, entry) => total + entry.value, 0);
  return (
    <MantineTable highlightOnHover stickyHeader fz="xs" mah={500}>
      <MantineTable.Thead>
        <MantineTable.Tr>
          <MantineTable.Th w={402}>Date Completed</MantineTable.Th>
          <MantineTable.Th w={168} tt="capitalize">
            Logged {units}
          </MantineTable.Th>
          <MantineTable.Th />
        </MantineTable.Tr>
      </MantineTable.Thead>

      <MantineTable.Tbody>
        {participant.activity_log
          .sort((current, next) => new Date(current.date).getTime() - new Date(next.date).getTime())
          .map((activity, index) => (
            <ActivityLogTableRow
              activity={activity}
              key={index}
              index={index}
              participant={participant}
            />
          ))}

        <MantineTable.Tr fw={600}>
          <MantineTable.Td>Total</MantineTable.Td>
          <MantineTable.Td>{total}</MantineTable.Td>
        </MantineTable.Tr>
      </MantineTable.Tbody>
    </MantineTable>
  );
};

export { ActivityLogTable };
